var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "95%" } },
    [
      _vm.files.length > 0
        ? _c(
            "div",
            { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
            _vm._l(_vm.files, function(file, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "btn btn-link fileitem",
                  staticStyle: { padding: "1rem", "text-align": "center" },
                  on: {
                    click: function($event) {
                      _vm.downloadFile(file)
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-times",
                    staticStyle: { "padding-left": "0em" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.deleteFile(file)
                      }
                    }
                  }),
                  _vm._v(" "),
                  file.filetype === "pdf"
                    ? _c("i", {
                        staticClass: "fa fa-file-pdf-o fa-4x",
                        staticStyle: { "padding-left": "0em" }
                      })
                    : file.filetype === "csv"
                    ? _c("i", {
                        staticClass: "fa fa-file-code-o fa-4x",
                        staticStyle: { "padding-left": "0em" }
                      })
                    : file.filetype === "png" || file.filetype === "jpg"
                    ? _c("i", {
                        staticClass: "fa fa-file-image-o fa-4x",
                        staticStyle: { "padding-left": "0em" }
                      })
                    : file.filetype === "txt"
                    ? _c("i", {
                        staticClass: "fa fa-file-text-o fa-4x",
                        staticStyle: { "padding-left": "0em" }
                      })
                    : _c("i", {
                        staticClass: "fa fa-file-o fa-4x",
                        staticStyle: { "padding-left": "0em" }
                      }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  file.titulo
                    ? _c("span", [_vm._v(_vm._s(file.titulo))])
                    : _c("span", [_vm._v("Fichero sin nombre")])
                ]
              )
            })
          )
        : [_c("br"), _vm._v(" "), _vm._m(0)],
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.hasPermision("E")
            ? _c("b-col", [
                _c("input", {
                  staticClass: "inputfile",
                  attrs: { type: "file", name: "file", id: "file" },
                  on: {
                    change: function($event) {
                      _vm.uploadFile($event.target.files)
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "file" } }, [
                  _c("span", { staticClass: "btn btn-success" }, [
                    _vm._v("Subir fichero")
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { color: "red" } }, [
      _c("strong", [_vm._v("No se han encontrado ficheros.")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Details/comercial_multimedia.vue?vue&type=template&id=15fd82fa&
// module id = null
// module chunks = 